import { useCallback, type ChangeEvent } from 'react';
import { useTheme } from '@mui/material';
import { createSyntheticFileEvent } from './useInputsDragAndDrop';

type UseKlydoFileInputProps = {
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
};
const useKlydoFileInput = ({
  onFileChange,
  onRemoveFile,
}: UseKlydoFileInputProps) => {
  const { spacing, palette } = useTheme();

  const handleFileChange = useCallback(
    (file: File) => {
      onFileChange(createSyntheticFileEvent(file));
    },
    [onFileChange],
  );

  const handleRemoveFile = useCallback(() => {
    onRemoveFile();
  }, [onRemoveFile]);

  return { spacing, handleFileChange, palette, handleRemoveFile };
};
export default useKlydoFileInput;
